"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var systemFormConfigApi = _interopRequireWildcard(require("@/api/systemFormConfig.js"));
var _Parser = _interopRequireDefault(require("@/components/FormGenerator/components/parser/Parser"));
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 注意：和Parser唯一的区别就是这里仅仅传入表单配置id即可自动加载已配置的表单
 *      数据后渲染表单，
 *      其他业务和Parser保持一致
 */
// 权限判断函数
var _default = exports.default = {
  name: 'ZBParser',
  components: {
    parser: _Parser.default
  },
  props: {
    formName: {
      type: String,
      required: ''
    },
    isCreate: {
      type: Number,
      default: 0 // 0=create 1=edit
    },
    editData: {
      type: Object
    },
    keyNum: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      loading: false,
      formConf: {
        fields: []
      }
    };
  },
  watch: {
    keyNum: {
      handler: function handler(val) {
        this.formConf = {
          fields: []
        };
        this.handlerGetFormConfig(this.formName);
      },
      deep: true,
      immediate: false
    }
  },
  mounted: function mounted() {
    this.handlerGetFormConfig(this.formName);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handlerGetFormConfig: function handlerGetFormConfig(formName) {
      var _this = this;
      // 获取表单配置后生成table列
      this.loading = true;
      var _pram = {
        name: encodeURIComponent(formName)
      };
      systemFormConfigApi.formTempNameInfoApi(_pram).then(function (data) {
        _this.formConf = JSON.parse(data.content);
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (formValue) {
      this.$emit('submit', formValue);
    }),
    resetForm: function resetForm(formValue) {
      this.$emit('resetForm', formValue);
    }
  }
};